import { notification } from "antd";
import "./Notification.scss";

const Notification = (status, message: any) => {
  return notification[status]({
    message: message,
    placement: "bottomLeft",
    duration: 4,
    className: "notification",
  });
};

export default Notification;
